<template>
  <div class="TextTwoColumnContentBlock">
    <div class="grid">
      <div class="col-10-12 push-1-12 sm-push-0 sm-col-1-1">
        <UIHeadingType
          class="mb-xxlg"
          :heading-type="content.seoHeadingtype"
          :title="content.title"
        />
      </div>
      <div class="col-5-12 push-1-12 sm-push-0 sm-col-1-1 sm-mb-lg">
        <span
          class="raw"
          v-html="content.text1"
        />
      </div>

      <div class="col-5-12 sm-col-1-1">
        <span
          class="raw"
          v-html="content.text2"
        />
      </div>
      <div class="col-10-12 push-1-12 sm-push-0 sm-col-1-1">
        <UIContentblockButton
          class="btn btn-tertiary mt-xlg"
          :name="content.linkObject1?.name"
          :link="content.linkObject1?.link"
          :target="content.linkObject1?.target"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { TextTwoColumnContent } from '@/types/contentblocks'
  import type { ElocusPage, BreadCrumb } from '@tc8l/nuxt-base'

  defineProps<{
    content: TextTwoColumnContent
    breadCrumb?: BreadCrumb[]
    settings?: ElocusPage
    contentblockIdx?: number
  }>()
</script>
